export const CONNECTING_DELAY = 1000
export const KEEP_ALIVE_DELAY = 90000
